import type { PortableTextBlock, PortableTextTextBlock } from "sanity";
/**
 * Old content in Escenic often contained empty paragraphs (<p></p>).
 * If a "block" has no marks and only one child with empty text, remove it
 */
export function stripEmptyParagraphs(text: PortableTextBlock[]): PortableTextBlock[] {
    return text.filter(ptp => {
        if ("children" in ptp) {
            const block = ptp as PortableTextTextBlock;
            if ((block.markDefs?.length ?? 0) === 0 && block.children.length === 1 && block.children[0].text === "" && block.children[0]._type === "span") {
                return false;
            }
        }
        return true;
    });
}
//#endregion